// src/components/print.js
import Charts from "./Charts";

// -------------------------------
// MAIN PRINT LAYOUT
// -------------------------------
const PrintLogoOnly = () => (
  <div className="print-logo-only">
    <img className="ph-logo" src="/PRY_Logo_Light.png" alt="Logo" />
  </div>
);


const toNumber = (value) => {
  if (value === null || value === undefined) return 0;
  if (typeof value === "number") return value;

  const cleaned = String(value).replace(/[$,]/g, "");
  const parsed = Number(cleaned);

  return isNaN(parsed) ? 0 : parsed;
};

const formatMT = (value) => {
  const num = toNumber(value);

  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(2)}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(0)}K`;
  return `${num.toFixed(0)}`;
};

const formatUSD = (value) => {
  const num = toNumber(value);

  if (num >= 1_000_000_000) return `$${(num / 1_000_000_000).toFixed(1)}B`;
  if (num >= 1_000_000) return `$${(num / 1_000_000).toFixed(1)}M`;
  return `$${num.toFixed(0)}`;
};



export function PrintLayout({ summary, stats, charts, isLightMode = true }) {
  if (!summary || !stats || !charts) return null;

// -------------------------------
// PRINT DATE (STATIC DEFAULT)
// -------------------------------
const displayDateRange = summary.dateRange;


 
  return (
    <div className="print-page print-only">

      {/* HEADER */}
      <div className="print-header">
        <img className="ph-logo" src="/PRY_Logo_Light.png" alt="Logo" />
        <div className="ph-title">Peer Imports Dashboard</div>
      </div>

<div className="print-date-bar">
  {displayDateRange}
</div>




   
<div className="descriptor-grid-modern">

  {[
    { label: "Importer", value: summary.buyer },
    { label: "Exporter", value: summary.seller },
    { label: "Country", value: summary.country },
    { label: "Category", value: summary.category },
  ].map((item, i) => (
    <div key={i} className="descriptor-box">
      <div className="descriptor-title">{item.label}</div>
  <div className="descriptor-values">
  {String(item.value || "All")
    .split(",")
    .map(v => v.trim())
    .filter(v => v.length > 0)
    .map((v, idx) => (
      <div key={idx}>{v}</div>
    ))}
</div>

    </div>
  ))}

</div>






      {/* STATS ROW */}
      <div className="stats-row">

        <div className="stat-box border-blue">
         <div className="stat-value">
  {formatMT(stats.metricTons)}
</div>
          <div className="stat-label">METRIC TONS</div>
          <div className="stat-sub">Total Weight Imported</div>
        </div>

        <div className="stat-box border-green">
          <div className="stat-value">
  {formatUSD(stats.totalValue)}
</div>
          <div className="stat-label">TOTAL VALUE</div>
          <div className="stat-sub">Total Calculated Value</div>
        </div>

        <div className="stat-box border-blue">
          <div className="stat-value">
  ${toNumber(stats.valPerKg).toFixed(2)}
</div>
          <div className="stat-label">VAL / KG</div>
          <div className="stat-sub">Average Value per Kilogram</div>
        </div>

      </div>

      {/* CHARTS */}
      <div className="print-charts-wrapper">

        {/* FIRST PAGE — FIRST TWO CHARTS (smaller to fit with header/stats) */}
        <div className="print-chart-page print-chart-page-first">
          {charts.slice(0, 2).map((c, i) => (
            <div key={i} className="print-chart print-chart-small">
<div className="print-chart-container">
  <Charts
    data={c.data}
    chartType={c.chartType}
    isLightMode={isLightMode}
    isPrint={true}
    forceRender={true}
    hideTitleInChart={true}
  />
</div>

            </div>
          ))}
        </div>

        {/* REMAINING PAGES — TWO CHARTS PER PAGE (larger) */}
        {Array.from({ length: Math.ceil((charts.length - 2) / 2) }).map((_, pageIndex) => {
  const startIndex = 2 + pageIndex * 2;
  const pageCharts = charts.slice(startIndex, startIndex + 2);
const pageClass =
  pageCharts.length === 1
    ? "print-chart-page single-chart-page"
    : "print-chart-page multi-chart-page";

  return (
    <div key={pageIndex} className={pageClass}>

      <PrintLogoOnly />

      {pageCharts.map((c, i) => (

                <div key={i} className="print-chart">
                  <div className="print-chart-container">
                    <Charts
                      data={c.data}
                      chartType={c.chartType}
                      isLightMode={isLightMode}
                      isPrint={true}
                      forceRender={true}
                    />
                  </div>
                </div>
              ))}
            </div>
          );
        })}

      </div>

    </div>
  );
}